/*
 * @Date: 2021-01-27 11:13:13
 * @Author: lvjun
 * @Description: main
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import components from '@/components'
//引入ElementUI
import ElementUI from 'element-ui';
import('element-ui/lib/theme-chalk/index.css')
Vue.use(ElementUI);

import * as Api from '@/api'
import * as filters from '@public/utils/filters.js'
import ImagePreview from '@/components/ImagePreview/instance'
import exportCenterDialogNew from '@/components/ImagePreview/instance'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
import plugins from '@public/plugins/index'
// 注册插件
plugins.install()
// Avue组件库
import Avue from './components/avuex/index'
import('./components/avuex/styles/index.scss')
Vue.use(Avue);

//引入样式
import '@/assets/style/reset.scss'
import('./assets/style/index.scss')
import('./assets/iconfont/iconfont')

// 时间组件
import demon from '@jms/demon'
import('@jms/demon/dist/theme-chalk/index.css')
Vue.use(demon, { fetch, langJsonMap: store.state.base.langJson })

components.registerGlobalComponents()

Vue.prototype.$API = Api
Vue.prototype.$openImagePreview = ImagePreview().open
Vue.prototype.$exportCenterDialogNew = exportCenterDialogNew().open
// 设置默认皮肤
window.document.body.setAttribute('data-theme', localStorage.getItem('preTheme') ? localStorage.getItem('preTheme') + '-theme' : 'default-theme')

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
window.addEventListener('message', (messageEvent) => {
  // 在线客服一键录单
  if (messageEvent.data.event === 'fastRecord') {
    store.dispatch('SET_VUESTORAGE', { servicemessageEvent: messageEvent.data.result })
  }
  // 在线客服当前接待列表
  if (messageEvent.data.event === 'userList') {
    store.dispatch('SET_VUESTORAGE', { servicemessageUserList: messageEvent.data.result })
  }
  // 在线客服切换接待用户
  if (messageEvent.data.event === 'clickChat') {
    store.dispatch('SET_VUESTORAGE', { servicemessageUserCode: messageEvent.data.result })
  }
  // 紫金山一键录单
  if (messageEvent.data.event === 'trillFastRecord') {
    console.log('【trillFastRecord】messageEvent: ', messageEvent);
    store.dispatch('SET_TRILLSTORAGE', { rapidCatalogue: messageEvent.data.result })
  }
  // 紫金山当前接待列表
  if (messageEvent.data.event === 'trillUserList') {
    console.log('【trillUserList】messageEvent: ', messageEvent);
    store.dispatch('SET_TRILLSTORAGE', { receptionUserList: messageEvent.data.result })
  }
  // 紫金山切换接待用户
  if (messageEvent.data.event === 'trillClickChat') {
    console.log('【trillClickChat】messageEvent: ', messageEvent);
    store.dispatch('SET_TRILLSTORAGE', { receptionUserCode: messageEvent.data.result })
  }
  const {event, result} = messageEvent.data
   // 自研一键录单
  if (event === 'imCatalogue') {
    store.dispatch('SET_IMSTORAGE', { imCatalogue: result })
  }
  // 自研当前接待列表
  if (event === 'imUserList') {
    store.dispatch('SET_IMSTORAGE', { imUserList: result })
  }
  // // 自研切换接待用户
  // if (event === 'imClickChat') {
  //   store.dispatch('SET_IMSTORAGE', { imClickChat: result })
  // }
  // 录单小助手ai数据
  console.log(event,result,'event>>>')
  if (event === 'imOrderSuggest') {
    store.dispatch('SET_IMSTORAGE', { imOrderSuggestData: result })
  }
})
